import type React from 'react';

export const calculateShowOnBottom = (tooltipRef: React.RefObject<HTMLElement | null>, isMobile?: boolean) => {
  const offsetPixels = 8;
  const navBarHeight = isMobile ? 40 : 55;
  const filterBarHeight = isMobile ? 56 : 72;
  const navHeight = navBarHeight + filterBarHeight + offsetPixels;
  const tooltipTop = tooltipRef?.current?.getBoundingClientRect()?.top;

  const isAboveNav = tooltipTop ? tooltipTop < navHeight : false;
  const isBelowViewport = tooltipTop ? tooltipTop > window?.innerHeight : false;
  return isAboveNav || isBelowViewport;
};
